import { useDispatch, useSelector } from 'react-redux';
import { excludeDishes as excludeDishesAction } from '../actions';
import { getIsExcluding, getExcludeError } from '../selectors';

/**
 * Excludes dishes from the New (Global) Dishes view.
 *
 * @returns {[excludeDishes, *, *]}
 */
const useExcludeDishes = () => {
  const dispatch = useDispatch();
  const isExcluding = useSelector(getIsExcluding);
  const excludeError = useSelector(getExcludeError);

  const excludeDishes = (formulaCodes = []) => {
    if (formulaCodes.length === 0) {
      return;
    }
    dispatch(excludeDishesAction(formulaCodes));
  };

  return [excludeDishes, isExcluding, excludeError];
};

export default useExcludeDishes;
